module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/right-6c84700cd20644a7f15b768d2fd0fd6f.svg";